var TabComponent = (function () {
    var config = {
        tabContainer: '.tab_component',
        tabLink: '.tab_component .tab-link',
        dropdownButton: '.tab_component .dropdown-toggle',
        dropdownButtonText: '.tab_component .dropdown-toggle .text',
        dropdownButtonIcon: '.tab_component .dropdown-toggle .icon',
        dropdownButtonIconPath: '.tab_component .dropdown-toggle .icon path',
        navTabs: '.tab_component .nav-tabs',
        mobileBreakpoint: 768,
        tabContentContainer: '.tab-pane',
    };

    // Constructor
    function TabComponent() {
        //intentionally left empty
    }

    TabComponent.prototype.init = function () {
        var self = this;

        self.bindEvents();

        // Initial check when the document is ready
        self.showHideNavTabs();

        // Check when the window is resized
        $(window).resize(function () {
            self.showHideNavTabs();
        });
    };

    TabComponent.prototype.bindEvents = function () {
        var self = this;
        $(config.tabLink).on('click', function () {
            $(config.dropdownButtonText).text($(this).text());
            self.showHideNavTabs();
            $(config.dropdownButton).attr('aria-expanded', 'false');
            $(config.tabContentContainer).attr('aria-hidden', 'true');
            var target = $(this).attr('href');
            $(target).attr('aria-hidden', 'false');
        });

        //hide nav tabs when clicked outside
        $(document).on('click', function (e) {
            if (
                !$(e.target).is(config.dropdownButton) &&
                !$(e.target).is(config.dropdownButtonText) &&
                !$(e.target).is(config.dropdownButtonIcon) &&
                !$(e.target).is(config.dropdownButtonIconPath)
            ) {
                $(config.navTabs).hide();
                $(config.dropdownButton).attr('aria-expanded', 'false');
            }
        });

        $(config.dropdownButton).on('click', function () {
            self.handleDropdownClick();
        });
    };

    TabComponent.prototype.handleDropdownClick = function () {
        if ($(config.navTabs).is(':visible')) {
            $(config.navTabs).hide();
            $(config.dropdownButton).attr('aria-expanded', 'false');
            return;
        }

        $(config.navTabs).show();
        $(config.dropdownButton).attr('aria-expanded', 'true');
    };

    TabComponent.prototype.showHideNavTabs = function () {
        if ($(window).width() < config.mobileBreakpoint) {
            $(config.navTabs).hide();
            $(config.dropdownButton).show();
            $(config.dropdownButton).css({ display: 'flex' });
        } else {
            $(config.navTabs).show();
            $(config.dropdownButton).hide();
        }
    };
    $(config.dropdownButtonIcon).click(function (event) {
        event.stopPropagation();
        const $parent = $(this).parent();
        $parent.triggerHandler('click');
    });

    return TabComponent;
})();

$(document).ready(function () {
    if ($('.tab_component').length > 0) {
        new TabComponent().init();
    }

    function removeTabindex() {
        $('.tab_component .nav-tabs .tab-link').removeAttr('tabindex');
    }
    removeTabindex();

    // Ensure tabindex is removed when any .tab-link is clicked
    $('.tab_component .nav-tabs .tab-link').on('click', function () {
        removeTabindex();
    });

    // Re-check and remove tabindex when window is fully loaded
    $(window).on('load', removeTabindex);

    // Continuously monitor changes and remove tabindex dynamically
    var observer = new MutationObserver(function () {
        removeTabindex();
    });

    // Observe the parent container for any DOM changes
    var targetNode = document.querySelector('.tab_component .option-list-items');

    if (targetNode) {
        // Observe the parent container for any DOM changes
        observer.observe(targetNode, {
            attributes: true,
            childList: true,
            subtree: true,
        });
    }
});

// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.c02-tabs",
        "events": [
            {
                "eventTarget": ".nav-tabs .nav-item .tab-link",
                "eventType": "click",
                "tags": {
                    "componentId": "c02",
                    "componentName": "tabs",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tab",
                    "event": "navigation",
                    "eventType": "tab click",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": "",
                    "eventLabel": ""
                }
            }
        ]
    },
    {
        "target": ".tab_component",
        "events": [
            {
                "eventTarget": ".nav-tabs .tab-link.active",
                "eventType": "click",
                "tags": {
                    "event": "componentInteraction",
                    "componentType": "Horizontal Tabs",
                    "contentTitle": "",
                    "elementClicked": ""
                }
            }
        ]
    }
);